export enum AdvancedBookingCardTypeEnum {
  SUGGESTION = "SUGGESTION",
  FAVORITE = "FAVORITE",
  ADVANCED_BOOKING = "ADVANCED_BOOKING",
}
